import { IStateSliceDefaults, StateSliceName } from '../store.models';

import {
    FetchGameEvents,
    FetchPlayerEvents,
    FetchPlayerShiftEvents
} from './event.actions';
import { EPlayerEventsMode, IEventStateModel, IGameEventsRequestParams } from './event.models';

export const eventStateDefaults: IStateSliceDefaults<IEventStateModel> = Object.freeze({
    sliceName: StateSliceName.EVENT,
    defaults: {
        playerEventDefinitions: undefined,
        gameEventDefinitions: undefined,
        shiftEventDefinitions: undefined,
        flagDefinitions: undefined,
        gameEvents: undefined,
        playerEvents: undefined,
        playerShiftEvents: undefined
    }
});

/** Request params scoped to the current game and period, used when fetching events. */
export type TCurrentPeriodEventsParams = Pick<IGameEventsRequestParams, 'gameid' | 'period'>;

/**
 * Builds the API request params for fetching events in the current game period.
 *
 * @param gameId - The active game identifier.
 * @param period - The selected period as a string (e.g. from query params).
 * @returns Params ready for a fetch action, or `null` when either value is missing.
 */
export function getCurrentPeriodEventsParams(
    gameId: string | undefined,
    period: string | undefined
): TCurrentPeriodEventsParams | null {
    if (!gameId || !period) {
        return null;
    }

    return {
        gameid: [gameId],
        period: [parseInt(period, 10)]
    };
}

/**
 * Builds the fetch actions used to reload all event types for the current period.
 * Intended for a full manual refresh of the event list (e.g. the refresh button).
 *
 * @param params - The current game and period request params.
 */
export function buildFetchActionsForCurrentPeriod(
    params: TCurrentPeriodEventsParams
): [FetchGameEvents, FetchPlayerShiftEvents, FetchPlayerEvents] {
    return [
        new FetchGameEvents(params),
        new FetchPlayerShiftEvents(params),
        new FetchPlayerEvents({ ...params, mode: EPlayerEventsMode.RAW }),
    ];
}
